<template>
	<UButton
		color="white"
		variant="outline"
		:label="$t('Quick Pick')"
		class="rounded-full min-w-48 max-h-12 text-neutral-50 text-base hover:no-underline font-semibold flex justify-center transform btn-try"
		:loading="props.loading"
		@click="onClick"
		@mouseover="mouseOver(true)"
		@mouseleave="mouseOver(false)"
	>
		<template #leading>
			<DicesIcon
				class="transition-icon"
				:class="{ 'rotate-icon': isHovered }"
				:size="40"
			/>
		</template>
	</UButton>
</template>

<script setup lang="ts">
import DicesIcon from '~/components/icons/DicesIcon.vue'

defineOptions({
	name: 'BtnTryRandom',
})

const props = defineProps({
	onClick: {
		type: Function,
		required: true,
	},
	loading: {
		type: Boolean,
		default: false,
	},
})

const { t: $t } = useI18n()

const isHovered = ref(false)

const mouseOver = (value: boolean) => {
	if (props.loading) return
	isHovered.value = value
}
</script>

<style scoped>
.btn-try {
	.transition-icon {
		transition: transform 0.5s ease-in-out;
	}
	.rotate-icon {
		transform: rotate(-210deg);
	}
}
</style>
